/* eslint-disable */
import app from '../dva'
import dvaDynamic from 'dva/dynamic'


app.model(require("/builds/oEfW_JFt/0/mcfe/midc-trust-center/src/models/global.js").default)

app.model(require("/builds/oEfW_JFt/0/mcfe/midc-trust-center/src/models/menu.js").default)

app.model(require("/builds/oEfW_JFt/0/mcfe/midc-trust-center/src/models/setting.js").default)


export const pathMap = {
  home: "/",
  homepage: "/home",
  security: "/security/vulnerability-management",
}

const routes = [{
  "path": "/",
  "name": "home",
  "icon": "",
  "component": dvaDynamic({
    app,
    component: () => import('/builds/oEfW_JFt/0/mcfe/midc-trust-center/src/layouts/BasicLayout'),
  }),
  "hideInMenu": false,
  "hideChildrenInMenu": false,
  "hide": false,
  "exact": false,
  "target": "",
  "title": "首页",
  "routes": [{
      "path": "/",
      "redirect": "/home?locale=zh",
      "exact": true
    },
    {
      "path": "//*",
      "redirect": "/security/vulnerability-management",
      "exact": true
    },
    {
      "path": "/home",
      "name": "homepage",
      "title": "首页",
      "component": dvaDynamic({
        app,
        component: () => import('/builds/oEfW_JFt/0/mcfe/midc-trust-center/src/pages/HomePage/Index'),
      }),
      "exact": true
    },
    {
      "path": "/security/vulnerability-management",
      "name": "security",
      "title": "安全模块",
      "component": dvaDynamic({
        app,
        component: () => import('/builds/oEfW_JFt/0/mcfe/midc-trust-center/src/pages/SecureModule/Index'),
      }),
      "children": [{
          "path": "/vulnerability-submission",
          "name": "submission",
          "title": "漏洞提交",
          "component": "@/pages/SecureModule/Submission/submission"
        },
        {
          "path": "/vulnerability-disclosure",
          "name": "disclosure",
          "title": "漏洞披露",
          "component": "@/pages/SecureModule/Disclosure/disclosure"
        },
        {
          "path": "/vulnerability-announcement",
          "name": "announcement",
          "title": "安全公告",
          "component": "@/pages/SecureModule/Announcement/announcement",
          "models": [
            "@/pages/SecureModule/model.js"
          ]
        },
        {
          "path": "/vulnerability-announcement/detail",
          "name": "detail",
          "title": "安全公告",
          "component": "@/pages/SecureModule/Detail/detail",
          "models": [
            "@/pages/SecureModule/model.js"
          ]
        }
      ],
      "exact": true
    }
  ]
}]

export default routes